import { Button, Modal, Spin, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import noticeTypes from "../../../../constants/noticeTypes";
import noticeTypeToRussian from "../../../../constants/noticeTypeToRussian";
import useCreateNoticeCancel from "../../../../hooks/useCreateNoticeCancel";
import { createNoticePopupState } from "../../../../store/actions/actions";
import getTemplates from "../../../../store/thunks/getTemplates";
import Buttons from "./Buttons";
import "./CreateNotice.scss";
import EmailSettings from "./EmailSettings";
import EntryPage from "./EntryPage";
import PhoneSettings from "./PhoneSettings";
import PlayConfirm from "./PlayConfirm";
import PushSettings from "./PushSettings";
import SMSSettings from "./SMSSettings";

const PAGES = {
	PUSH: PushSettings,
	PHONE: PhoneSettings,
	EMAIL: EmailSettings,
	SMS: SMSSettings,
};

const CreateNotice = () => {
	const dispatch = useDispatch();
	const onCancel = useCreateNoticeCancel();
	const { page, lastPage, popupOpened, pageName, debtors } = useSelector(
		(store) => store.debtsStore.createNotice
	);
	const [chosenNoticeTypes, setChosenNoticeTypes] = useState(
		noticeTypes.reduce((acc, noticeType) => {
			acc[noticeType.typeName] = false;
			return acc;
		}, {})
	);

	const [loading, setLoading] = useState();
	const [templates, setTemplates] = useState([]);
	useEffect(() => {
		(async () => {
			setLoading(true);
			const allTemplates = await getTemplates();
			setTemplates(allTemplates);
			setLoading(false);
		})();
	}, []);
	const templatesByType = useMemo(() => {
		return templates?.reduce((acc, template) => {
			if (!acc[template.typeName]) {
				acc[template.typeName] = [];
			}
			acc[template.typeName].push(template);
			return acc;
		}, {});
	}, [templates]);
	const [playConfirm, setPlayConfirm] = useState();

	useEffect(() => {
		dispatch(
			createNoticePopupState({
				lastPage: Number(
					Object.values(chosenNoticeTypes).filter(Boolean).length
				),
				chosenNoticeTypes,
			})
		);
	}, [chosenNoticeTypes]);

	useEffect(() => {
		if (!popupOpened) {
			setChosenNoticeTypes(
				noticeTypes.reduce((acc, noticeType) => {
					acc[noticeType.typeName] = false;
					return acc;
				}, {})
			);
		}
	}, [popupOpened]);

	useEffect(() => {
		const indexShown = page - 1;
		const noticesArray = Object.entries(chosenNoticeTypes)
			.filter(([_noticeType, value]) => value)
			.map(([noticeType]) => noticeType);
		const shownNotice = noticesArray[indexShown];
		dispatch(
			createNoticePopupState({
				pageName: shownNotice,
			})
		);
		if (page === 0) {
			dispatch(
				createNoticePopupState({
					pageName: 0,
				})
			);
		}
	}, [page]);

	if (loading) {
		return (
			<Spin spinning={loading}>
				<div />
			</Spin>
		);
	}

	const CurrentPage = PAGES[pageName];

	return (
		<>
			{!debtors?.length && (
				<Tooltip title="Выберите задолженности, по которым нужно сделать оповещение">
					<Button
						className="button button-disabled"
						onClick={() => {
							if (debtors?.length) {
								dispatch(
									createNoticePopupState({
										popupOpened: true,
									})
								);
							}
						}}
					>
						Создать оповещение о задолженности
					</Button>
				</Tooltip>
			)}
			{!!debtors?.length && (
				<Button
					disabled={!debtors?.length}
					className="button secondary_button"
					onClick={() => {
						dispatch(
							createNoticePopupState({
								popupOpened: true,
							})
						);
					}}
				>
					Создать оповещение о задолженности
				</Button>
			)}
			{popupOpened && (
				<Modal
					style={{ minWidth: "650px" }}
					title={`Оповещение о задолженности${
						pageName ? `: ${noticeTypeToRussian[pageName]}` : ""
					} (${page + 1}/${lastPage + 1})`}
					visible={popupOpened}
					onCancel={() => {
						setPlayConfirm(false);
						onCancel();
					}}
					footer={
						playConfirm ? null : <Buttons setPlayConfirm={setPlayConfirm} setLoading={setLoading}/>
					}
				>
					<div className="create_notice_modal">
						{page === 0 && !playConfirm && (
							<EntryPage
								setChosenNoticeTypes={setChosenNoticeTypes}
								chosenNoticeTypes={chosenNoticeTypes}
							/>
						)}
						{!playConfirm && PAGES[pageName] && (
							<CurrentPage templates={templatesByType[pageName]} />
						)}

						{playConfirm && <PlayConfirm setPlayConfirm={setPlayConfirm} setLoading={setLoading}  />}
					</div>
				</Modal>
			)}
		</>
	);
};

export default CreateNotice;
